import React, { useState, PropsWithChildren, SetStateAction, Dispatch, useCallback } from "react";
import type { BookingInterface } from "types/booking";
import type { DataAccount } from "types/bookService";
import { ServiceInterface } from "types/service";

export interface ReferencesProviderInterface {
    setBooking: Dispatch<SetStateAction<BookingInterface | undefined>>;
    getBooking: () => BookingInterface | undefined;
    getDataAccount: () => DataAccount | undefined;
    setDataAccount: Dispatch<SetStateAction<DataAccount | undefined>>;
    getService: () => ServiceInterface | undefined;
    setService: Dispatch<SetStateAction<ServiceInterface | undefined>>;
}

const BookingContext = React.createContext<ReferencesProviderInterface>({
    setBooking: () => [],
    getBooking: () => undefined,
    getDataAccount: () => undefined,
    setDataAccount: () => undefined,
    getService: () => undefined,
    setService: () => undefined,
});

const Consumer = BookingContext.Consumer;

const Provider: React.FC<PropsWithChildren<{}>> = ({ children }) => {
    const [booking, setBooking] = useState<BookingInterface>();
    const [dataAccount, setDataAccount] = useState<DataAccount | undefined>();
    const [service, setService] = useState<ServiceInterface | undefined>();

    const getBooking = useCallback(() => {
        return booking;
    }, [booking]);

    const getDataAccount = useCallback(() => {
        return dataAccount;
    }, [dataAccount]);

    const getService = useCallback(() => {
        return service;
    }, [service]);

    return (
        <BookingContext.Provider
            value={{
                setBooking,
                getBooking,
                setDataAccount,
                getDataAccount,
                setService,
                getService,
            }}
        >
            {children}
        </BookingContext.Provider>
    );
};

export { Provider, Consumer, BookingContext as Context };
